import { render, staticRenderFns } from "./CzAccordion.vue?vue&type=template&id=4ce54213&scoped=true&"
import script from "./CzAccordion.vue?vue&type=script&lang=ts&"
export * from "./CzAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./CzAccordion.vue?vue&type=style&index=0&id=4ce54213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce54213",
  null
  
)

export default component.exports